import mutations from './mutations';
import getters from './getters';

function state() {
    return {
        isDisabled: false,
        isLoadingMediaForm: false,
        approval_flows: [],
        selected_approval_flow: null,
        selected_cost_share_approver: null,
        expires_in_days_options: [],
        cost_splits: [],
        org_users: [],
        allowed_networks: [],
        social_media_networks: [],
        show_social_media_settings: false,
        post_message: null,
        post_message_length: 280,
        groups: [],
        team_connection_access: false,
        template_print_settings: {
            print_company: null,
            te_sku: null,
            printer_sku: null,
            rates: []
        },
        auto_pay_available: false,
        social_website_fields: [],
        preview_image_url: null,
        twitter_url_length: 35,
        user_types: [],
        allowed_comarketer_user_types: [],
        show_organization_select: false,
        show_template_select: false,
        organizations: [],
        force_redirect: false,
        has_media_template_permission: false,
        auto_pay_org_share: false,
        templates: [],
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters
};